import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

export const OPTIONS_TAB_COUPONS = ['Produto Físico', 'Produto Digital'];

export const useCoupon = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabActive, setTabActive] = useState(() => {
    const showParams = searchParams.get('show');
    const tabDefault = '0';

    if (!showParams || showParams === 'physic') return tabDefault;

    return showParams === 'digital' ? '1' : tabDefault;
  });

  const [isSelectAddCouponModalOpen, setIsSelectAddCouponModalOpen] =
    useState(false);

  const handleOpenModalCoupon = useCallback(
    () => setIsSelectAddCouponModalOpen(true),
    []
  );

  const handleCloseModalCoupon = useCallback(
    () => setIsSelectAddCouponModalOpen(false),
    []
  );

  const handleSetTabActive = useCallback(
    (key: string) => {
      setTabActive(key);
      setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        params.set('show', key === '0' ? 'physic' : 'digital');
        return params;
      });
    },
    [setTabActive]
  );

  useBreadcrumbs([
    {
      label: 'Gestão de Cupons',
    },
  ]);

  return {
    isSelectAddCouponModalOpen,
    handleCloseModalCoupon,
    handleOpenModalCoupon,
    tabActive,
    handleSetTabActive,
  };
};
